// E-MotionSpec Environment Configuration
//
// Environment variables are loaded from:
// - .env.local for local development
// - .env.production for production builds

// Default values (emotionspec production)
const DEFAULTS = {
  apiUrl: 'https://emotionspec.autismailab.com/api',
  userPoolId: 'us-east-1_c0kcXA5BF',
  clientId: '3b1btu44gc3qamplm0qhkpvt7u',
  cognitoDomain: 'emotionspec-prod-513786434698.auth.us-east-1.amazoncognito.com',
  bucket: 'emotionspec-data-513786434698-prod',
  region: 'us-east-1',
};

export const config = {
  production: import.meta.env.PROD,

  // API Gateway
  apiUrl: import.meta.env.VITE_API_URL || DEFAULTS.apiUrl,

  // Cognito Configuration
  cognito: {
    userPoolId: import.meta.env.VITE_COGNITO_USER_POOL_ID || DEFAULTS.userPoolId,
    clientId: import.meta.env.VITE_COGNITO_CLIENT_ID || DEFAULTS.clientId,
    domain: import.meta.env.VITE_COGNITO_DOMAIN || DEFAULTS.cognitoDomain,
    region: import.meta.env.VITE_AWS_REGION || DEFAULTS.region,
  },

  // S3 Configuration (used via API presigned URLs)
  s3: {
    bucket: import.meta.env.VITE_S3_BUCKET || DEFAULTS.bucket,
    region: import.meta.env.VITE_AWS_REGION || DEFAULTS.region,
  },
} as const;

// AWS Amplify configuration - using direct sign-in (no OAuth)
export const amplifyConfig = {
  Auth: {
    Cognito: {
      userPoolId: config.cognito.userPoolId as string,
      userPoolClientId: config.cognito.clientId as string,
    },
  },
};
